niacs.controllers = angular.module('NiacsProjectApp.controllers', [
    'NiacsProjectApp.controllers-general',
    'NiacsProjectApp.controllers-dashboard',
    'NiacsProjectApp.controllers-overview',
    'NiacsProjectApp.controllers-step1',
    'NiacsProjectApp.controllers-step2',
    'NiacsProjectApp.controllers-step3',
    'NiacsProjectApp.controllers-step4',
    'NiacsProjectApp.controllers-step5',
    'NiacsProjectApp.controllers-export-share',
    'NiacsProjectApp.controllers-homework'
])
.run(['$rootScope','TaxonomyService','UserProfileService','AutoSaveService','RedirectionService',
    function($rootScope,TaxonomyService,UserProfileService,AutoSaveService,RedirectionService){
    // init stuff
    $rootScope.niacs = niacs;
    $rootScope.isSaving = AutoSaveService.isSaving;
    $rootScope.visit = RedirectionService.visit;
    UserProfileService.get(function(p){
        $rootScope.userProfile = p;
    });
    TaxonomyService.get('state',function(data){
        $rootScope.vocab_state = data;
    });
    TaxonomyService.get('niacs_project_ownership',function(data){
        $rootScope.vocab_ownership = data;
    });
    TaxonomyService.get('niacs_feasibility',function(data){
        $rootScope.vocab_feasibility = data;
    });
    TaxonomyService.get('tactic_practicability',function(data){
        $rootScope.vocab_tactic_practicability = data;
    });
    TaxonomyService.get('niacs_vulnerability',function(data){
        $rootScope.vocab_vulnerability = data;
    });
}])
/**
 * Simple controller for the slow down dialog (yertle)
 */
.controller('SlowDownDialogCtrl',['$scope','$uibModalInstance','ProjectService','CustomTextService','project','textKey',function($scope,$uibModalInstance,ProjectService,CustomTextService,project,textKey){
    $scope.textKey = textKey;
    CustomTextService.object(textKey).then(function(text){
        $scope.text = text;
    });
    if(!project.meta || (project.meta && angular.isArray(project.meta))) { project.meta = {}; }
    if(!project.meta.noNag || (project.meta.noNag && angular.isArray(project.meta.noNag))) { project.meta.noNag = {}; }
    $scope.project = project;
    $scope.ModuleUrl = niacs.ModuleUrl;
    $scope.dismiss = $uibModalInstance.dismiss;
    $scope.close = $uibModalInstance.close;
    $scope.$watch('project.meta.noNag[text.label]',function(){
        if(typeof $scope.project.meta.noNag[$scope.text.label] != 'undefined') {
            niacs.debug("Saving updated no nag for " + $scope.text.label + " to " + $scope.project.meta.noNag[$scope.text.label]);
            ProjectService.save();
        }
    });
}])
.directive('menuCollapse',['$window','$timeout',function($window,$timeout){
    return {
        restrict: 'A',
        link: function($scope,$elem,$attrs) {
            var $ = ($||jQuery),
                menu_height,
                nested_selector = '.nav-hr,.nav-nonstep',
                clickon = function(selected) {
                    selected.css('cursor','pointer');
                    selected.click(click);
                },
                clickoff = function(selected) {
                    selected.off('click',click);
                    selected.css('cursor','');
                },
                click = function(event){
                    var self = $(this),
                        show = function() { self.nextUntil(nested_selector).slideDown(); },
                        showTimer,
                        hrs = $elem.find('.nav-hr');
                    clickoff(self);
                    hrs.each(function(){
                        var hr = $(this),
                            active = false;
                        hr.nextUntil(nested_selector).each(function(){
                            if($(this).hasClass('active')) {
                                active = true;
                            }
                        });
                        if(!active){
                            hr.nextUntil(nested_selector).slideUp(function(){
                                clearTimeout(showTimer);
                                showTimer = setTimeout(show,400);
                            });
                            if(self[0] !== hr[0]) {
                                clickon(hr);
                            }
                        }
                    });
                },
                expand = function() {
                    $elem.find('.nav-step').slideDown();
                    clickoff($elem.find('.nav-hr'));
                },
                contract = function() {
                    var hrs = $elem.find('.nav-hr');
                    hrs.each(function(){
                        var hr = $(this),
                            active = false;
                        hr.nextUntil(nested_selector).each(function(){
                            if($(this).hasClass('active')) {
                                active = true;
                            }
                        });
                        if(!active) {
                            hr.nextUntil(nested_selector).slideUp();
                            clickon(hr);
                        } else {
                            hr.nextUntil(nested_selector).slideDown();
                            clickoff(hr);
                        }
                    });
                };
            function resizer() {
                if($elem.height() === 0) {
                    return $timeout(resizer,250);
                }
                // initialize this only once with the fully expanded menu height
                // so we're making decisions based on what the expanded menu height would be
                // regardless of the menu's state (i.e. "will it fit in the window?")
                if(!menu_height) {
                    menu_height = $elem.height();
                }
                // the offset.top-scrollTop bit below is odd since the menu is fixed but
                // jQuery returns a larger than correct offset.top when the window is scrolled down
                var bottom_edge = menu_height+($elem.offset().top-$(document).scrollTop()),
                    window_height = $($window).height();
                ((bottom_edge > window_height) ? contract : expand)();
            }
            $($window).resize(resizer);
            $scope.$on('$locationChangeSuccess',function(){ $timeout(resizer,500); });
            // shouldn't happen but just to be proper
            $scope.$on('$destroy',function(){
                $($window).off('resize',resizer);
            });
        }
    };
}])
/**
 * Menu controller (nothing to control at the moment).
 */
.controller('MenuCtrl',['$scope','$location','$routeParams','$uibModal','$sce','CustomTextService','ProjectService','ShowHideService','MenuService','CourseOfferingService',
    function($scope,$location,$routeParams,$uibModal,$sce,CustomTextService,ProjectService,ShowHideService,MenuService,CourseOfferingService){
        $scope.go = function(item) {
          if(item) {
              ProjectService.afterSave(function(){
                  $location.url(item.toString());
              });
          }
        };
        $scope.slowDown = true;
        function findActive() {
            if($scope.current && $scope.menuItems) {
                angular.forEach($scope.menuItems,function(item){
                    item.active = MenuService.isMenuItemActive(item,$scope.current);
                });
            }
        }
        ProjectService.get($routeParams,'MenuCtrl',function(project){
            $scope.project = project;
            MenuService.getFlatMenu($routeParams,'MenuCtrl.Menu').then(function(flatMenu){
                $scope.menuItems = flatMenu;
                findActive();
            });
        });
        $scope.$on('$locationChangeStart', function(event) {
            if(typeof($scope.current) === 'string' && $scope.slowDown) {
                var fromPath = MenuService.getMenuPath($scope.current),
                    custTextKey = "SLOWDOWN_"+fromPath.getStep().toUpperCase(),
                    toPath = MenuService.getMenuPath($location),
                    fromIdx,toIdx,i,noNag = false;
                if(CustomTextService.exists(custTextKey)) {
                    niacs.debug("Navigating from " + fromPath.toString() + " to " + toPath.toString() + " and there is slow down text for " + custTextKey);
                    noNag = $scope.project && $scope.project.meta && $scope.project.meta.noNag && $scope.project.meta.noNag[custTextKey];
                    if(noNag) {
                        niacs.debug("User has set no-nag flag for " + custTextKey);
                    } else {
                        // look through the menu and see if they're moving forward or backward.
                        for(i = 0; i < $scope.menuItems.length; i++) {
                            if(fromPath.compareToMenuItem($scope.menuItems[i])) {
                                fromIdx = i;
                            } else if(toPath.compareToMenuItem($scope.menuItems[i])) {
                                toIdx = i;
                            }
                        }
                        if(toIdx > fromIdx) { // moving forward
                            niacs.debug("Navigating forward prompting the user to slow down.");
                            // throw up a dialog containing the text to make the user "think".
                            event.preventDefault(); // stop don't let them move forward.
                            $uibModal.open({
                                templateUrl: 'partials/dialogs/slow-down.html',
                                controller: 'SlowDownDialogCtrl',
                                windowClass: 'niacs-slow-down-dialog',
                                keyboard: false,
                                backdrop: 'static',
                                resolve: {
                                    textKey: function() { return custTextKey; },
                                    project: function() { return $scope.project; }
                                }
                            }).result.then(function(){
                                // set slowDown to false so that they don't get re-prompted when
                                // attempting to leave this step again.
                                niacs.debug("The user chose to move on.");
                                $scope.slowDown = false;
                                $location.path(toPath.toString()); // they said move on.
                            },function(){});
                        }
                    }
                }
            } else {
                $scope.slowDown = true;
            }
            ShowHideService.reset();
        });
        $scope.$on('$locationChangeSuccess', function(event) {
            $scope.current = $location.path();
            findActive();
            $(window).scrollTop(0);
        });
        $scope.$on('$dockedChange',function(event,changed/*the panel state that just changed*/,docked/*the curently docked panel, if any*/){
            $scope.dockedPanel = docked;
        });
        // welcome dialog
        $scope.welcomeShown = false; // make sure it's only shown at most once per visit
        function welcome() {
            if($scope.welcomeShown) {
                return;
            }
            var custTextKey ='SLOWDOWN_WELCOME',
                flatMenu = niacs.flattenMenu(),
                path = $location.path(),
                to = path.split('/')[1],noNag;
            if( ($scope.welcomeShown = to != flatMenu[0].item) ) {
                // pretend the welcome was shown if the UI enters somewhere other than the overview (i.e. refresh)
                return;
            }
            if(!$scope.welcomeShown && CustomTextService.exists(custTextKey) && $scope.project) {
                noNag = $scope.project.meta && $scope.project.meta.noNag && $scope.project.meta.noNag[custTextKey];
                if(!noNag) {
                    // present the welcome dialog
                    $uibModal.open({
                        templateUrl: 'partials/dialogs/welcome.html',
                        controller: 'SlowDownDialogCtrl', // re-use the slowdown dialog controller
                        windowClass: 'niacs-welcome-dialog',
                        keyboard: false, // no dismis via ESC
                        backdrop: 'static', // no dismiss via clicking outside.
                        resolve: {
                            textKey: function() { return custTextKey; },
                            project: function() { return $scope.project; }
                        }
                    }).result.then(function(){
                        for(var i = 0; i < flatMenu.length; i++) {
                            if(flatMenu[i].item) {
                                path = '/'+flatMenu[i].item+'/'+$scope.project.id;
                                break;
                            }
                        }
                        $location.path(path); // they said move on.
                    },function(){});
                    $scope.welcomeShown = true;
                }
            }
        }
        // this allows for over-riding of the welcome dialog contents when a project is associated with
        // a course offering and that offering has defined welcome dialog contents. need to make sure we
        // have in hand both the project and global custom texts.  If there's a course offering with welcome
        // dialog contents then over-ride the SLOWDOWN_WELCOME
        function pre_welcome() {
            CourseOfferingService.getForProject($scope.project).then(function(offering){
                if(offering && offering.materials && offering.materials.welcome && offering.materials.welcome.content) {
                    CustomTextService.replace('SLOWDOWN_WELCOME',{
                        label: 'SLOWDOWN_WELCOME',
                        text: offering.materials.welcome.content,
                        html: $sce.trustAsHtml(offering.materials.welcome.content)
                    });
                }
                welcome();
            });
        }
        $scope.$watch('project', function(p) {
            if(p) {
                CustomTextService.object('SLOWDOWN_WELCOME').then(function(obj){
                    pre_welcome();
                });
            }
        });
}])
.controller('ResourcesCtrl',['$scope','$routeParams','ProjectService',
    function($scope,$routeParams,ProjectService){
        ProjectService.get($routeParams,'ResourcesCtrl',function(project){
            $scope.project = project;
        });
}])
.controller('AutoSaveCtrl',['$scope','AutoSaveService',
    function($scope,AutoSaveService) {
        $scope.isSaving = AutoSaveService.isSaving;
}])
.controller('ProjectHeaderCtrl',['$scope','$routeParams','ProjectService',
    function($scope,$routeParams,ProjectService) {
        ProjectService.get($routeParams,'ProjectHeaderCtrl',function(p){
            $scope.project = p;
        });
}])
.controller('ProjectOverviewCtrl',['$scope','$routeParams','ProjectService',
    function($scope,$routeParams,ProjectService) {
        ProjectService.get($routeParams,'ProjectOverviewCtrl',function(p){
            $scope.project = p;
        });
}])
.controller('JustProjectCtrl',['$scope','$routeParams','ProjectService',
    function($scope,$routeParams,ProjectService) {
        ProjectService.get($routeParams,'JustProjectCtrl',function(p){
            $scope.project = p;
        });
}]);
